import { createSelector } from "reselect";
import { getClientSettings } from "./client.state";

const getCurrentUser = (state) => state?.currentUser;
const getMeta = (state) => state?.meta;

export const getUserEmail = createSelector(
  getCurrentUser,
  (currentUser) => currentUser?.email?.value
);

export const getUserRole = createSelector(
  getCurrentUser,
  (currentUser) => currentUser?.role?.value?.value
);

export const getUserAgencies = createSelector(getCurrentUser, (currentUser) =>
  currentUser?.agencies?.value?.filter((agency) => agency.slug !== null)
);

export const getClientSlug = createSelector(
  getCurrentUser,
  (currentUser) => currentUser?.client?.value?.slug
);

export const getClientBrand = createSelector(
  getCurrentUser,
  (currentUser) => currentUser?.client?.value?.brand
);

export const getPOSEnabled = createSelector(
  getClientSettings,
  (clientSettings) => clientSettings?.pointOfSale?.value?.enabled
);

export const getPaymentPortalURL = createSelector(
  getMeta,
  (meta) => meta?.value?.paymentPortalUrl?.value
);
